var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"view form-view",attrs:{"id":"user-create-view"}},[_c('h2',[_vm._v("Create driver")]),_c('driver-form',{attrs:{"form":_vm.form,"handler":_vm.createDriver}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }